
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(4(31|57|79)|5(13|69|79)|9(52|74|85)|021|13|36|679|773|861)|2(6(19|58|92)|(|9)29|[14]33|361|840|867)|5(9(63|66|71)|3(09|46|78|79|87)|6(37|4|89|91)|529|583|734|77)|6(139|185|419|732|793|894)|1(7(15|19|33|89)|240|331|485|657|879)|8([45]30|(44|6|62|76)3|025|154|181|347|897|964|992)|7(5(31|47|49)|1(07|51|95|97)|(20|65|79)3|059|325|38|475|49|632|998)|3(4(03|41|43)|69(|7)|7(15|21|81)|(12|13|3)1|05|37|535|92|943)|9(9(|25|69)|049|457|488|614|815|833))$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
